import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  TextField
} from '@mui/material'
import React, {useState} from 'react'
import {useAppSelector, useAppDispatch} from '../../../redux/storeExports'
import {
  selectAccountEmail,
  selectCompanyFederation,
  selectMuid,
} from '@meprism/shared/src/redux/authentication/authenticationSlice'
import ResetPassword from '../../Authentication/ResetPassword'
import {theme} from '../../../theme/DashboardTheme'
import {MfaCard} from '../../Authentication/MfaCard'
import DeleteAcc from './DeleteAcc'
import { redeemCodeForWeb } from '../../../redux/product/ProductSlice'

const styles = {
  card: {borderRadius: 3, background: '#f6f6f6'},
  fontBold: {fontFamily: 'InterSemiBold', color: 'black'},
  fontGray: {
    color: '#767676',
  },
}

const AccSecurity = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [code, setCode] = useState('')
  const accountEmail = useAppSelector(selectAccountEmail)
  const muid = useAppSelector(selectMuid)
  const dispatch = useAppDispatch()
  const companyFederation = useAppSelector(selectCompanyFederation)
  const mainComponent = () => {
    return (
      <Grid container columnSpacing={5} rowSpacing={5}>
        {!isMobile && (
          <Grid item xs={12} md={12}>
            <Typography variant="h3">Account & Security</Typography>
          </Grid>
        )}
        <Grid item xs={12} md={5}>
          <Card sx={styles.card}>
            <CardContent>
              <Typography variant="subtitle2" sx={styles.fontBold}>
                Sign in Email
              </Typography>
              <Box sx={{paddingBlockStart: '0.5rem'}}>
                <Typography variant="caption" sx={styles.fontGray}>
                  {accountEmail}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card sx={styles.card}>
            <CardContent>
              <Grid container columnSpacing={5}>
                <Grid item md={10}>
                  <Typography variant="subtitle2" sx={styles.fontBold}>
                    mePrism ID
                  </Typography>
                  <Box sx={{paddingBlockStart: '0.5rem'}}>
                    <Typography variant="caption" sx={styles.fontGray}>
                      {muid}{' '}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item md={2} sx={{textAlign: 'right'}}>
                  <Typography
                    variant="caption"
                    onClick={() =>
                      navigator.clipboard.writeText(muid as string)
                    }
                    sx={{
                      cursor: 'pointer',
                      color: '#c67eff',
                    }}>
                    Copy
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={12} xs={12}>
          <Divider/>
        </Grid>
        {!companyFederation && <ResetPassword/>}
        <Grid item md={12} xs={12}>
          <Divider/>
        </Grid>
        <MfaCard/>
        <Grid item md={12} xs={12}>
          <Divider/>
        </Grid>
        <Grid item
          md={12} xs={12}
              >
            <Typography variant="h3" component="div" sx={{marginBottom: '18px'}}>
              Have a Code?
            </Typography>
        
            <Typography variant="h4" color={'#615F6B'}>
              Redeem Code
            </Typography>
            <Grid container sx={{ width: '100%' }}>
              <Grid item md={5} xs={12} mt={2} mr={!isMobile ? 5:0}>
                <TextField
                    sx={{ background: '#fff' }}
                      fullWidth
                      value={code}
                      onChange={(event) => setCode(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12} mt={2}>
                <Button
                  sx={{
                          width:isMobile? '100%':'40%',
                          height: 45,
                          borderRadius: '10px',
                          border: '2px solid #C67EFF',
                          background: 'transparent',
                          color: '#C67EFF',
                          '&.Mui-disabled': {
                            background: 'transparent',
                            color: '#C67EFF',
                          },
                          ':hover': {
                            background: '#C67EFF',
                            color: '#fff',
                          },
                    }}
                    onClick={() => dispatch(redeemCodeForWeb(code))}>
                        Apply
                  </Button>
              </Grid>
            </Grid>
        </Grid>
        <Grid item md={12} xs={12}>
          <Divider/>
        </Grid>
        <DeleteAcc/>
      </Grid>
    )
  }
  return (
    <>
      {isMobile ? (
        mainComponent()
      ) : (
        <Card sx={{borderRadius: 5, overflow: 'auto', boxShadow: 'none'}}>
          <CardContent>{mainComponent()}</CardContent>
        </Card>
      )}
    </>
  )
}

export default AccSecurity
